module.exports = __webpack_public_path__ + "officialStatic/img/wirelessBanner.4a35cff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/wirelessBanner.jpg
// module id = KONl
// module chunks = 0